import React, { useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import Api from "../../api/api";

const UserTable = ({ refreshTrigger }) => {
  const [userData, setUserData] = useState({ columns: [], rows: [] });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newStatus, setNewStatus] = useState("");

  const fetchUserData = async () => {
    try {
      const users = await Api.fetchUsers();

      const columns = [
        { Header: "ID", accessor: "id", width: "20%", align: "left" },
        { Header: "Name", accessor: "name", align: "left" },
        { Header: "Mobile", accessor: "phone", align: "left" },
        { Header: "Devices", accessor: "devices", align: "left" },
        { Header: "Status", accessor: "status", align: "center" },

        { Header: "Action", accessor: "action", align: "center" },
      ];

      // const rows = users.map((user, index) => {
      //   // Collect all device IDs for this user
      //   const alldevices = user.user_devices
      //     ? user.user_devices.map(element => element?.device_id).filter(Boolean).join(", ")
      //     : "";

      //   return {
      //     id: index + 1,
      //     name: user.name,
      //     phone: user.phone,
      //     devices: alldevices,
      //     status: (
      //       <span
      //         data-testid={`status-${user.id}`}
      //         style={{ color: user.status === 1 ? "green" : "red", fontWeight: 500 }}>
      //         {user.status === 1 ? "Active" : "Inactive"}
      //       </span>
      //     ),
      //     action: (
      //       <div
      //         style={{
      //           display: "flex",
      //           gap: "15px",
      //           justifyContent: "center",
      //         }}
      //       >
      //         <button
      //           data-testid={`update-button-${user.id}`}
      //           onClick={() => openStatusModal(user)}
      //           style={{
      //             color: "#7b809a",
      //             background: "transparent",
      //             border: "none",
      //             cursor: "pointer",
      //             fontWeight: "500",
      //           }}
      //           onMouseOver={(e) => (e.target.style.color = "#007bff")}
      //           onMouseOut={(e) => (e.target.style.color = "#7b809a")}
      //         >
      //           Update
      //         </button>
      //       </div>
      //     ),
      //   };
      // });

      const rows = users.map((user, index) => {
        // Collect all device IDs for this user
        const alldevices = user.user_devices
          ? user.user_devices.map(element => element?.device_id).filter(Boolean)
          : [];

        return {
          id: index + 1,
          name: user.name,
          phone: user.phone,
          devices: (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {alldevices.length > 0
                ? alldevices.map((deviceId, i) => (
                  <span
                    key={deviceId || i}
                    style={{
                      background: "#e3f2fd",
                      color: "#1976d2",
                      borderRadius: "12px",
                      padding: "2px 10px",
                      fontSize: "12px",
                      fontWeight: 500,
                      border: "1px solid #90caf9",
                      marginBottom: "2px",
                    }}
                  >
                    {deviceId}
                  </span>
                ))
                : <span style={{ color: "#999" }}>No Devices</span>
              }
            </div>
          ),
          status: (
            <span
              data-testid={`status-${user.id}`}
              style={{ color: user.status === 1 ? "green" : "red", fontWeight: 500 }}>
              {user.status === 1 ? "Active" : "Inactive"}
            </span>
          ),
          action: (
            <div
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "center",
              }}
            >
              <button
                data-testid={`update-button-${user.id}`}
                onClick={() => openStatusModal(user)}
                style={{
                  color: "#7b809a",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
                onMouseOver={(e) => (e.target.style.color = "#007bff")}
                onMouseOut={(e) => (e.target.style.color = "#7b809a")}
              >
                Update
              </button>
            </div>
          ),
        };
      });
      setUserData({ columns, rows });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const openStatusModal = (user) => {
    setSelectedUser(user);
    setNewStatus(user.status === 1 ? "1" : "0");
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setModalOpen(false);
  };

  // const handleDelete = async (userId) => {
  //   try {
  //     const result = await Swal.fire({
  //       title: "Are you sure?",
  //       text: "You won't be able to revert this!",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "Yes, delete it!",
  //       cancelButtonText: "Cancel"
  //     });

  //     if (result.isConfirmed) {
  //       await Api.deleteUser(userId);
  //       Swal.fire("Deleted!", "User has been deleted.", "success");
  //       fetchUserData();
  //     }
  //   } catch (error) {
  //     console.error("Error deleting user:", error);
  //     Swal.fire("Error!", "Failed to delete user.", "error");
  //   }
  // };

  const handleStatusUpdate = async () => {
    try {
      await Api.updateUserStatus(selectedUser.id, newStatus === "1");
      Swal.fire("Success!", "User status updated.", "success");
      fetchUserData();
      closeModal();
    } catch (error) {
      console.error("Error updating user status:", error);
      Swal.fire("Error!", "Failed to update user status.", "error");
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [refreshTrigger]);

  return (
    <>
      <DataTable
        table={userData}
        entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15] }}
        canSearch
        showTotalEntries
        isSorted={false}
      />

      {/* Modal */}
      {modalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 50,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "24px",
              borderRadius: "10px",
              width: "320px",
              textAlign: "center",
              boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
            }}
          >
            <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "16px" }}>
              Update Status for{" "}
              <span style={{ color: "#007bff" }}>{selectedUser?.name}</span>
            </h3>
            <select
              data-testid="status-select"
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                marginBottom: "20px",
                border: "1px solid #ccc",
              }}
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                data-testid="update-status-button"
                onClick={handleStatusUpdate}
                style={{
                  background: "#007bff",
                  color: "white",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Update
              </button>
              <button
                data-testid="cancel-button"
                onClick={closeModal}
                style={{
                  background: "#ccc",
                  color: "black",
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserTable;
